<template>
    <div class="builder-specifications-type-1">
        <SpecificationExamples />

        <template v-for="(facetsSection, i) in facetsSections" :key="i">
            <SpecificationFacets :config="facetsSection" />
        </template>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useDatasetStore } from '@/stores/dataset';
    import SpecificationExamples from '@/components/builder/specification/SpecificationExamples';
    import SpecificationFacets from '@/components/builder/specification/SpecificationFacets';
    import { orgtypeMap } from '@/utils/maps/orgtypeMap';
    import { socialMap } from '@/utils/maps/socialMap';
    import { provinceMap } from '@/utils/maps/provinceMap';

    export default {
        name: 'BuilderOptions',
        components: {
            SpecificationExamples,
            SpecificationFacets
        },
        data() {
            return {
                facetsSections: [
                    {
                        slug: 'general',
                        type: 'kpi',
                        dataSource: 'data_exists',
                        values: ['address', 'phone', 'email', 'url', 'register_id', 'vat'],
                        default: true
                    },
                    {
                        slug: 'sbi',
                        type: 'sbi',
                        dataSource: 'sbi',
                        order: 'numerical',
                        default: false
                    },
                    {
                        slug: 'employees',
                        type: 'list',
                        dataSource: 'employees_range',
                        order: 'numerical',
                        default: false
                    },
                    {
                        slug: 'revenue',
                        type: 'list',
                        dataSource: 'revenue_range',
                        order: 'numerical',
                        default: false
                    },
                    {
                        slug: 'province',
                        type: 'kpi',
                        dataSource: 'province',
                        map: provinceMap,
                        default: false
                    },
                    {
                        slug: 'socials',
                        type: 'kpi',
                        dataSource: 'data_exists',
                        values: ['linkedin', 'facebook', 'twitter', 'instagram', 'youtube', 'pinterest'],
                        map: socialMap,
                        default: false
                    },
                    {
                        slug: 'apps',
                        type: 'kpi',
                        dataSource: 'apps_cat',
                        values: ['cms', 'webmail', 'ecommerce', 'marketing automation', 'analytics', 'tag managers', 'web servers', 'databases', 'cdn'],
                        default: false
                    },
                    {
                        slug: 'orgtype',
                        type: 'list',
                        dataSource: 'orgtype',
                        map: orgtypeMap,
                        default: false
                    }
                ]
            }
        },
        computed: {
            ...mapState(useDatasetStore, ['dataset', 'facets', 'defaultDataset'])
        },
        methods: {
            ...mapActions(useDatasetStore, ['updateDataset']),
            onChanged() {
                this.updateDataset();
            }
        }
    }
</script>